import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20684 42994"
    {...props}
  >
    <path
      d="M6873 16406c-1681 967-2951 1449-3809 1449-802 0-1518-323-2134-959-627-637-930-1380-930-2223 0-978 303-1693 910-2153 617-450 1694-1047 3240-1772 995-465 1902-942 2723-1429v7087zm6937-13721c835-1153 1398-1871 1676-2166 323-343 940-519 1841-519 1008 0 1830 391 2437 1174 617 784 920 1860 920 3241v32813c0 3847-1311 5766-3935 5766-1165 0-2105-392-2810-1175-44-49-87-98-129-150V2685z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
